var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-nib-straight-thin",
    transform: "translate(0.184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 20,
    height: 20,
    transform: "translate(-0.184)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_10",
    "data-name": "Ligne 10",
    y2: 8,
    transform: "translate(9.816 11)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8.816 9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M72,27.707V24.618A.618.618,0,0,1,72.618,24h7.413a.618.618,0,0,1,.618.618v3.089",
    transform: "translate(-66.483 -22.147)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M45.967,72l-2.116,4.278a.633.633,0,0,0,.054.641l6.386,8.672,6.386-8.672a.633.633,0,0,0,.054-.641L54.616,72Z",
    transform: "translate(-40.45 -66.44)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventSupport);
export default __webpack_public_path__ + "static/media/eventSupport.8092b93c06bd0ec323a029ef264c50e9.svg";
export { ForwardRef as ReactComponent };